import React, { useEffect, useState } from "react";
import ProfileStage from "./ProfileStage";
import AadhaarStage from "./AadhaarStage";
import DLStage from "./DLStage";
import EmailStage from "./EmailStage";
import { textCapitalize } from "../../../Helpers/Utils";
import ThirdDocument from "./ThirdDocument";
import FinalVerify from "./FinalVerify";
import { hideModalThen } from "../../../Helpers/ModalUtils";

const Index = ({ stage, customer, onCustomerUpdate }) => {
    // Bumped every time the modal finishes closing, so the next opening starts with empty forms
    // (otherwise half-typed numbers / photos from the last time are still there).
    const [openCount, setOpenCount] = useState(0);

    useEffect(() => {
        const modalEl = document.getElementById("stageModal");
        const onHidden = () => setOpenCount((n) => n + 1);
        modalEl?.addEventListener("hidden.bs.modal", onHidden);
        return () => modalEl?.removeEventListener("hidden.bs.modal", onHidden);
    }, []);

    // Close the modal first and refresh the customer only once it is really gone. Refreshing first
    // swapped the whole page for a loading skeleton while the modal was still open, which could leave
    // the dimmed backdrop and the page-scroll lock behind.
    const handleVerified = () => {
        hideModalThen("stageModal", () => onCustomerUpdate?.());
    };

    const wideStages = ["final", "profile", "third"];
    const modalSizeClass = wideStages.includes(stage) ? "modal-lg" : "";

    return (
        <div className="modal fade" id="stageModal" tabIndex="-1" aria-labelledby="stageModalLabel" aria-hidden="true">
            <div className={`modal-dialog modal-dialog-centered ${modalSizeClass}`}>
                <div className="modal-content border-0 shadow-sm rounded-4">
                    <div className="modal-header">
                        <h5 className="modal-title" id="stageModalLabel">{textCapitalize(stage)} Verification</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body" key={`${stage}-${openCount}`}>
                        {!customer ? (
                            <div className="text-center p-4">
                                Loading...
                            </div>
                        ) : (
                            <>
                                {stage === "profile" && (
                                    <ProfileStage customerDetails={customer} onVerified={handleVerified} />
                                )}

                                {stage === "email" && (
                                    <EmailStage customerDetails={customer} onVerified={handleVerified} />
                                )}

                                {stage === "aadhaar" && (
                                    <AadhaarStage customerDetails={customer} onVerified={handleVerified} />
                                )}

                                {stage === "dl" && (
                                    <DLStage customerDetails={customer} onVerified={handleVerified} />
                                )}

                                {stage === "third" && (
                                    <ThirdDocument customerDetails={customer} onVerified={handleVerified} />
                                )}

                                {stage === "final" && (
                                    <FinalVerify customerDetails={customer} onVerified={handleVerified} />
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Index;
